// COPY FROM man-eula-web
const eulaCountries = {
    AUSTRIA: 'Austria',
    BELGIUM_DUTCH: 'Belgium_Dutch',
    BELGIUM_FRENCH: 'Belgium_French',
    BULGARIA: 'Bulgaria',
    CROATIA: 'Croatia',
    CYPRUS: 'Cyprus',
    CZECH_REPUBLIC: 'Czech_Republic',
    DENMARK: 'Denmark',
    ESTONIA: 'Estonia',
    FINLAND: 'Finland',
    FRANCE: 'France',
    GERMANY: 'Germany',
    GREECE: 'Greece',
    HUNGARY: 'Hungary',
    IRELAND: 'Ireland',
    ITALY: 'Italy',
    LATVIA: 'Latvia',
    LITHUANIA: 'Lithuania',
    LUXEMBOURG: 'Luxembourg',
    MALTA: 'Malta',
    NETHERLANDS: 'Netherlands',
    POLAND: 'Poland',
    PORTUGAL: 'Portugal',
    ROMANIA: 'Romania',
    SLOVAKIA: 'Slovakia',
    SLOVENIA: 'Slovenia',
    SPAIN: 'Spain',
    SWEDEN: 'Sweden',
} as const;

export const resolveEulaCountry = (accountCountryCode: string, locale: string | undefined) => {
    if (accountCountryCode === 'DE') {
        return eulaCountries.GERMANY;
    } else if (accountCountryCode === 'AT') {
        return eulaCountries.AUSTRIA;
    } else if (accountCountryCode === 'BE') {
        if (locale?.startsWith('fr')) {
            // Sprachgruppenanteil 40 - 43 %
            return eulaCountries.BELGIUM_FRENCH;
        } else {
            // Sprachgruppenanteil 57 - 60 %, so treated as default
            return eulaCountries.BELGIUM_DUTCH;
        }
    } else if (accountCountryCode === 'BG') {
        return eulaCountries.BULGARIA;
    } else if (accountCountryCode === 'HR') {
        return eulaCountries.CROATIA;
    } else if (accountCountryCode === 'CY') {
        return eulaCountries.CYPRUS;
    } else if (accountCountryCode === 'CZ') {
        return eulaCountries.CZECH_REPUBLIC;
    } else if (accountCountryCode === 'DK') {
        return eulaCountries.DENMARK;
    } else if (accountCountryCode === 'EE') {
        return eulaCountries.ESTONIA;
    } else if (accountCountryCode === 'FI') {
        return eulaCountries.FINLAND;
    } else if (accountCountryCode === 'FR') {
        return eulaCountries.FRANCE;
    } else if (accountCountryCode === 'GR') {
        return eulaCountries.GREECE;
    } else if (accountCountryCode === 'HU') {
        return eulaCountries.HUNGARY;
    } else if (accountCountryCode === 'IE') {
        return eulaCountries.IRELAND;
        // } else if (accountCountryCode === 'IS') {
        //     return eulaCountries.ICELAND;
    } else if (accountCountryCode === 'IT') {
        return eulaCountries.ITALY;
        // } else if (accountCountryCode === 'LI') {
        //     return eulaCountries.LIECHTENSTEIN;
    } else if (accountCountryCode === 'LT') {
        return eulaCountries.LITHUANIA;
    } else if (accountCountryCode === 'LU') {
        return eulaCountries.LUXEMBOURG;
    } else if (accountCountryCode === 'LV') {
        return eulaCountries.LATVIA;
    } else if (accountCountryCode === 'MT') {
        return eulaCountries.MALTA;
    } else if (accountCountryCode === 'NL') {
        return eulaCountries.NETHERLANDS;
    } else if (accountCountryCode === 'PL') {
        return eulaCountries.POLAND;
    } else if (accountCountryCode === 'PT') {
        return eulaCountries.PORTUGAL;
    } else if (accountCountryCode === 'RO') {
        return eulaCountries.ROMANIA;
    } else if (accountCountryCode === 'SE') {
        return eulaCountries.SWEDEN;
    } else if (accountCountryCode === 'SI') {
        return eulaCountries.SLOVENIA;
    } else if (accountCountryCode === 'SK') {
        return eulaCountries.SLOVAKIA;
    } else if (accountCountryCode === 'ES') {
        return eulaCountries.SPAIN;
    } else if (accountCountryCode === 'TV') {
        if (locale?.startsWith('de')) {
            return eulaCountries.GERMANY;
        } else if (locale?.startsWith('fr')) {
            return eulaCountries.FRANCE;
        } else {
            return eulaCountries.IRELAND;
        }
    }
    return eulaCountries.IRELAND;
};
